import { LoadScript, type Libraries } from '@react-google-maps/api'
import { type ReactNode } from 'react'

import { env } from '@/app/env'
import { PageLoader } from '@/components/primitives/page-loader'

// `places` powers the Autocomplete widget + the Geocoder used for click-to-
// reverse-geocode in the location geolocation map field. `drawing` was dropped
// (Google Maps Drawing Library deprecated Aug 2025 / unavailable May 2026).
const LIBRARIES: Libraries = ['places']

const mapsLoadingElement = <PageLoader />

// The Google Maps script is mounted once at the app root so every map field
// shares a single loaded API instance. With no key configured the consumer
// (location geolocation field) renders its keyless fallback, so there is
// nothing to load — render children unwrapped instead of mounting a
// `LoadScript` that would silently fail to fetch the JS API.
export function MapsScript({ children }: { children: ReactNode }) {
  if (!env.googleMapsApiKey) return <>{children}</>

  return (
    <LoadScript
      googleMapsApiKey={env.googleMapsApiKey}
      libraries={LIBRARIES}
      language="en"
      loadingElement={mapsLoadingElement}
    >
      {children}
    </LoadScript>
  )
}
